/* ========================== */  
/* ========= import ========= */  
/* ========================== */  

/* ====== React ====== */
import React, { useState } from 'react';
import { useNavigate,useLocation } from 'react-router-dom';

/* ====== CSS ====== */
import styled from 'styled-components';

/* ====== Image ====== */
import tcicon from '05Images/tcicon.svg'
import account from '05Images/account.svg'

/* ====== Component Js/Jsx ====== */
import { FontSizeButton } from '02CommonUiParts/ButtonParts/FontSizeButton';
import { assets } from "03CommonApiParts/Configuration";
import { AUTHORITY_STORAGE, CODEDIFINITION_STORAGE, screenMaster, USERINFO_STORAGE } from '03CommonApiParts/CodeDefinition';
import { CFArrayFount } from '03CommonApiParts/CommonFunction';
import { useMsal } from '@azure/msal-react';
import { Dialog } from '02CommonUiParts/MessageParts/Dialog';

/* ========================== */  
/* ========= Styles ========= */  
/* ========================== */  

/* ====== Styled Components ====== */
/* ------ ヘッダー ------*/
const Sheader = styled.header`//ヘッダー枠
	width: 100%;
	min-width: fit-content;
	height: 52px;
	display: flex;
	box-sizing: border-box;
	justify-content: space-between;
	justify-content: center;
	background-color: #F4F8FA;
	color: #2E94B9;
	white-space: nowrap;
	z-index: 50;
	position: sticky;
	top: 0;
	border-bottom: 2px solid #D9D9D9;
`;
const SdivHeaderTitle = styled.div`//ヘッダータイトル
	line-height: 30px;
	font-weight: bold;
	background-color: #F4F8FA;
	padding-left: 10px;
	align-items: center;
	z-index: 50;
`;
const SsvgSettingIcon = styled.svg`//ヘッダーアイコン
	margin: 2px 0 0 10px;
	width: 35px;
`;
const LeftContents = styled.div`//ヘッダー左側のコンテンツ枠
	display: flex;
	width: 20%;
	align-items: center;
`;
const SdivCenterContents = styled.div`//ヘッダー真ん中のコンテンツ枠
	display: flex;
	justify-content: center;
	background-color: #F4F8FA;
	align-items: center;
	z-index: 50;
	margin: 0 auto;
	margin-right: auto;
	min-width: 640px;
	width: 60%;
`;
const SdivRightContents = styled.div`//ヘッダー右側のコンテンツ枠
	display: flex;
	width: 30%;
	justify-content: flex-end;
	align-items: center;
	z-index:50;
	margin-right: 10px;
`;
const SbuttonHeader = styled.button`//遷移ボタン
	line-height: 44px;
	margin-top: 3px;
	background-color: #F4F8FA;
	color: #898989;
	border: none;
	padding: 0px 15px;
	&:hover{
		cursor: pointer;
	}
	&:hover label {
		display: block;
	}

`;

const SdivUserInformation = styled.div`//ユーザー情報
	background-color: #F4F8FA;
	display: flex;
	cursor: pointer;
`;
const SdivUserInfoColumn = styled.div`//縦並びのユーザー情報
	display: flex;
	flex-direction: column;

`;
const Organizasion = styled.div`//ユーザーの組織情報
	margin: 0;
	padding: 0;
	height: 22px;
	max-width:	225px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	text-align:right;
`;
const UserName = styled.div`//ユーザー名
	height: 25px;
	max-width:	225px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	text-align:right;
`;
const SsvgAccountIcon = styled.svg` //SVG用
    width:40px;
    height:40px;
    padding:0 15px;
`;
const SdivMenuWrapper = styled.div`
	position: relative;
	cursor: pointer;
	:hover label {
		display: block;
	}
`;
const SlabelBalloon = styled.label` //グローバルナビゲーション用
	display: none;
	border-radius: 3px;
	position: absolute;
	z-index: 50;
	top: ${props=>props.baloonPositionTop ?props.baloonPositionTop:'-63px'};
	background-color: #fff;
	height: fit-content;
	padding: 13px;
	border: 1px solid #D9D9D9;
	left: 50%;
	transform: translate(-50%, 0px);
	:after{
		content: '';
		position: absolute;
		top:${props=>props.triangleTop ?props.triangleTop:'81%'};
        left: ${props=>props.triangleLeft ?props.triangleLeft:' 48%'};
		width: 20px;
		height: 20px;
		transform: translateY(-50%) rotate(-45deg) skew(10deg,10deg); /* POINT 要素を変形 */
		border-right: 1px solid #D9D9D9;
		border-top: 1px solid #D9D9D9;
		background-color: #fff;
	}

`;
const SdivContentsColumn = styled.div` //グローバルナビゲーション用
	display: flex;
	flex-wrap: wrap;
	width: ${props=>props.contentsWidth ?props.contentsWidth:''};
	div:only-child {
		width: auto;
	}
`;
const SdivContent = styled.label` //グローバルナビゲーション用
	min-width: ${props=>props.contentWidth ?props.contentWidth:''};
	height: 20px;
	padding: 10px;
	cursor: pointer;
	transition: all ease-in .1s;
	:hover{
		background-color: #2E94B9;
		color: #fff;
	}
`;


/* ========================== */  
/* ========== Main ========== */  
/* ========================== */  

export const Header = () =>{

    /* --------------------------- */
    /* --------- Instance -------- */
    /* --------------------------- */
	const navigate = useNavigate();//画面遷移用
	const location = useLocation();
	const { instance } = useMsal();

    /* --------------------------- */
    /* -------- variables -------- */
    /* --------------------------- */
	/* AUTHORITY_STORAGEから認可情報を取得 */
	const authorityStorage = sessionStorage.getItem(AUTHORITY_STORAGE);
	var authorityStorageValue = JSON.parse(authorityStorage);//JSON 文字列を取得し、JavaScriptオブジェクトに変換
	/* CODEDIFINITION_STORAGEからコード定義を取得 */
	const codeDefinitionStorage = sessionStorage.getItem(CODEDIFINITION_STORAGE);
	var codeDefinitionValue = JSON.parse(codeDefinitionStorage);//JSON 文字列を取得し、JavaScriptオブジェクトに変換
	const screenIdList = CFArrayFount(codeDefinitionValue,'code','screenId').list;
	/* USERINFO_STORAGEから従業員情報を取得 */
	const userInfoStorage = sessionStorage.getItem(USERINFO_STORAGE);
	var userInfoValue = JSON.parse(userInfoStorage);//JSON 文字列を取得し、JavaScriptオブジェクトに変換
	const userDept = userInfoValue.dptName;
	const userName = userInfoValue.empJpnSrname + ' ' + userInfoValue.empJpnName;

	/* --------------------------- */
    /* ---------- state ---------- */
    /* --------------------------- */
	const [dialogMessage, setDialogMessage] = useState({ //ダイアログ表示用
        open:false,
    });
    /* --------------------------- */
    /* -------- functions -------- */
    /* --------------------------- */

	/*------ ヘッダータイトル押下時 ------*/
	const onClickPageButton = (path) => {
		/* 画面遷移 */
		navigate(path);
	};

	/* ===== 大項目表示可否をチェック ===== */
	const checkDisplay = (target) =>{
		let result = 'block';
		// target.forEach((item)=>{
		// 	result = checkSubDisplay(item);
		// })
		result = target.some(item => checkSubDisplay(item) !== 'none') ? 'block' : 'none';
		return result
	}
	/* ===== 小項目表示可否をチェック ===== */
	const checkSubDisplay = (target) =>{
		let result = 'flex';

		/* idから権限大分類を取得 */
		const authName = CFArrayFount(screenMaster,'id',target).auth;
		/* 権限でmenuDiaplayが設定されているもの以外はtrueなる */
		const authorityList = CFArrayFount(authorityStorageValue,'authMinCtgrCd',authName)?.authSubCtgrCdList;
		if(!authorityList?.find((item)=>item === 'menuDisplay')){
			result = 'none';
		};
		return result
	}
	/* ===== アンダーバーの位置をチェック ===== */
	const checkUnderbar = (list) =>{
		let result = 'solid 3px #F4F8FA';
		list.forEach((item)=>{
			/* locationのpathと同じであれば、_を表示 */
			if(CFArrayFount(screenMaster,'id',item).path === location.pathname){
				result = 'solid 3px #FAA578';
			}
		});
		return result;
	};

	/* ヘッダーのリスト */
	const heaerMenuList = [
		{
			headName:'人事稟議一覧',
			list:['GetApprovalList']
		},
		{
			headName:'従業員情報操作',
			list:['GetInformationList','GetAssignedList']
		},
		{
			headName:'出力',
			list:['GetMoveInList','GetMoveOutList','GetAppointmentList','GetOrganizationCodeList','GetDepartmentTransferList','GetAcceptedList','GetTemporaryList','GetContractList','GetCheckList','GetAllItemList']
		},
		{
			headName:'マスタメンテ',
			list:['GetAuthorityList','GetDepartmentList','GetStatusList','GetGradeList','GetCostList','GetPositionList','GetRankList']
		}
	]
	
	const onClickLogout = () =>{
		const afterFunc = async() =>{
			await instance.logoutRedirect({
				postLogoutRedirectUri: "/common/logout",
			});
		}
		 /* 確認ダイアログ表示 */
		setDialogMessage({      
			...dialogMessage,
			open:true, 
			message:'CMNC005',//メッセージID(commonFunctionより対象のメッセージ)
			afterFunc:afterFunc,
			pattern: 2//1：OKボタンのみ表示　2：OKとキャンセルボタンを表示 3：OKとキャンセルと一時保存ボタンを表示
		});
	}
	
	// 
    /* ========================== */  
    /* ====== Start Render ====== */  
    /* ========================== */  
    return(
		<>
			<Sheader>
				<LeftContents>
					{/* ヘッダーに表示するシステム名 */}
						<>
							<SsvgSettingIcon transform = 'scale(1,-1)'>
								<use xlinkHref={`${tcicon}#tcicon`}></use>
							</SsvgSettingIcon>
							<SdivHeaderTitle className='headText' style={{fontSize:assets().size.headText}}>HRDB</SdivHeaderTitle>
						</>
				</LeftContents>
				{/* ヘッダーに表示するボタン */}
				<SdivCenterContents>
					<>
							{heaerMenuList.map((head,index)=>(
							head.list.length === 1 ?
							<SbuttonHeader 
								key={`head${index}`}
								className='baseText' 
								onClick={()=>onClickPageButton(CFArrayFount(screenMaster,'id',head.list[0]).path)}
								style={{ 
									display:checkSubDisplay(head.list[0]),
									borderBottom:checkUnderbar(head.list),
									fontSize:assets().size.baseText}}>
								{head.headName}
							</SbuttonHeader>
							:
							<SdivMenuWrapper key={`head${index}`}>
								<SbuttonHeader 
									className='baseText' 
									style={{ 
										display:checkDisplay(head.list),
										borderBottom:checkUnderbar(head.list),
										fontSize:assets().size.baseText}}>
									{head.headName}
								</SbuttonHeader>
								<SlabelBalloon 
									baloonPositionTop={head.headName === '従業員情報操作' ? '94%' : '94%'}//吹き出し四角の縦方向調整
									triangleTop={head.headName === '従業員情報操作' ? '0%' : '0%'}//吹き出し三角の縦方向調整
									>
									<SdivContentsColumn
										contentsWidth={
											(head.list.filter(item => checkSubDisplay(item) !== 'none')).length === 1 ?//小要素が１つなら幅をautoにする
												'auto'
											:head.headName === '出力' ? 
												'420px' 
											:head.headName === 'マスタメンテ' ? 
												'460px'
											:'200px'
										}
									>
										{head.list.filter(item => checkSubDisplay(item) !== 'none').map((item,i)=>(
											<SdivContent 
												key={`head${index}${i}`}
												contentWidth={head.headName === '従業員情報操作' ? '90%' : head.headName === 'マスタメンテ' ? '45%'  : '45%'}
												onClick={()=>onClickPageButton(CFArrayFount(screenMaster,'id',item).path)}>
												＞ {CFArrayFount(screenIdList,'value',item).label}
											</SdivContent>
										))}
									</SdivContentsColumn>
								</SlabelBalloon>
						</SdivMenuWrapper>
						))}
						
					</>
				</SdivCenterContents>
				{/* ヘッダーに表示するユーザー情報 */}
				<SdivRightContents className='baseText' style={{fontSize:assets().size.baseText}} >
					{/* フォントサイズを変更するボタン */}
					<FontSizeButton/>
					<SdivUserInformation onClick={()=>onClickLogout()}>
						{/* 人のマークのアイコンつける */}
						<SsvgAccountIcon>
							<use xlinkHref={`${account}#account`}></use>
						</SsvgAccountIcon>
						<SdivUserInfoColumn>
							<Organizasion>{userDept}</Organizasion>
							<UserName>{userName}</UserName>
						</SdivUserInfoColumn>
					</SdivUserInformation>
				</SdivRightContents>
			</Sheader>
			{/* ダイアログ */}
			<Dialog
				content={dialogMessage}
				set={setDialogMessage}
			/> 
        </>
    );
}

/* ========================== */  
/* ========= import ========= */  
/* ========================== */  

// /* ====== React ====== */
// import React from 'react';
// /* ====== CSS ====== */
// import styled from 'styled-components';
// /* ====== Component Js/Jsx ====== */
// import { assets } from "03CommonApiParts/Configuration";

// /* ========================== */  
// /* ========= Styles ========= */  
// /* ========================== */  

// /* ====== Styled Components ====== */
// /* ------ ヘッダー ------*/
// const Sheader = styled.header`//ヘッダー枠
// 	width: 100%;
// 	height: 30px;
// 	padding:10px 0;
// 	display: flex;
// 	justify-content: space-between;
// 	background-color:${assets().color.blue};
// 	color: white;
// 	white-space: nowrap;
// 	z-index: 40;
// 	position: fixed;
// 	top: 0;
// 	border-bottom: 2px solid #D9D9D9;
// `;
// const SdivHeaderTitle = styled.div`//ヘッダータイトル
// 	line-height: 30px;
// 	font-weight: bold;
// 	background-color:${assets().color.blue};
// 	padding-left: 10px;
// 	align-items: center;
// 	z-index: 40;
// `;

// const LeftContents = styled.div`//ヘッダー左側のコンテンツ枠
// 	display: flex;
	
// `;

// /* ========================== */  
// /* ========== Main ========== */  
// /* ========================== */  

// export const Header = () =>{

//     /* --------------------------- */
//     /* --------- Instance -------- */
//     /* --------------------------- */

//     /* --------------------------- */
//     /* -------- variables -------- */
//     /* --------------------------- */

// 	/* --------------------------- */
//     /* ---------- state ---------- */
//     /* --------------------------- */
//     /* --------------------------- */
//     /* -------- functions -------- */
//     /* --------------------------- */

//     /* ========================== */  
//     /* ====== Start Render ====== */  
//     /* ========================== */  
//     return(
// 		<>
// 			<Sheader>
// 				<LeftContents>
// 					{/* <SImgSettingIcon src={settingIcon}/> */}
// 					<SdivHeaderTitle className='headText' style={{fontSize:assets().size.headText}}>ヘッダー</SdivHeaderTitle>
// 				</LeftContents>
// 				{/* ヘッダーに表示するユーザー情報 */}
				
// 			</Sheader>
// 			{/* ダイアログ
// 			<Dialog
// 				content={dialogMessage}
// 				set={setDialogMessage}
// 				onClickOK={onClickDialogOK}
// 			/>  */}
//         </>
//     );
// }
